import { Link } from 'react-router-dom';

export default function Anliegen(props) {
  const handleCheck = e => {
    if (e.target.checked === false) {
      let copy = {...props.anliegen};
      delete copy[e.target.name];
      props.setAnliegen(Object.assign({}, copy));
    } else
      props.setAnliegen(Object.assign({}, props.anliegen, { [e.target.name]: !props.anliegen[e.target.name]}));
  }
  const handleTextChange = e => {
    if (e.target.value === '') {
      let copy = {...props.anliegen};
      delete copy[e.target.name];
      props.setAnliegen(Object.assign({}, copy));
    } else {
      props.setAnliegen(Object.assign({}, props.anliegen, { [e.target.name]: e.target.value}));
    }
  }


  return (
    <div id="anliegen">
      <h2>Für welches Anliegen möchtest Du einen Beratungstermin buchen?</h2>
      <div className="ccontent">
        <ul>
          <li>
            <label><input type='checkbox' name='altersvorsorge' onClick={(e) => handleCheck(e)}/>Nachhaltige Altersvorsorge</label>
          </li>
          <li>
            <label><input type='checkbox' name='vermoegensbildung' onClick={(e) => handleCheck(e)}/>Nachhaltige Vermögensbildung allgemein</label>
          </li>
          <li>
            <label><input type='checkbox' name='wertpapiere' onClick={(e) => handleCheck(e)}/>Nachhaltige Aktien, ETFs und Wertpapiere</label>
          </li>
          <li>
            <label><input type='checkbox' name='sachversicherung' onClick={(e) => handleCheck(e)}/>Sachversicherungsschutz (Haftpflicht, Hausrat, uvm.)</label>
          </li>
          <li>
            <label><input type='checkbox' name='krankenpflege' onClick={(e) => handleCheck(e)}/>Kranken- und Pflegeversicherung</label>
          </li>
          <li>
            <h4>Wenn möglich, beschreibe Dein Anliegen genauer. Das hilft Deiner Finanzexpert*in.</h4>
            <textarea name='anderes_field' rows={6} cols={60} onChange={e => handleTextChange(e)}></textarea>
          </li>
          <li>
           <label for="know_verde">Woher kennst Du ver.de?</label>
            <select name="know_verde" id="know_verde" required onChange={e => handleTextChange(e)}>
              <option value="">Bitte auswählen</option>
              <option value="instagram">Instagram</option>
              <option value="facebook">Facebook</option>
              <option value="linkedin">LinkedIn</option>
              <option value="newsletter">Newsletter</option>
              <option value="freunde">Freunde & Familie</option>
              <option value="sonstige">Sonstige</option>
            </select>
          </li>
        </ul>
        { Object.keys(props.anliegen).length >= 1 && props.anliegen['know_verde'] ?
        <Link className="ui button" to='/einverstaendnis'>Weiter</Link> :
        <Link className="ui button disabled">Weiter</Link>
        }
      </div>
    </div>
  )
}
